/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingconnecthint32Inputs */

const en_crosspostingconnecthint32 = /** @type {(inputs: Crosspostingconnecthint32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your login stays with Meta - Pulsify never sees your password.`)
};

const de_crosspostingconnecthint32 = /** @type {(inputs: Crosspostingconnecthint32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Anmeldung bleibt bei Meta – Pulsify sieht dein Passwort nie.`)
};

/**
* | output |
* | --- |
* | "Your login stays with Meta - Pulsify never sees your password." |
*
* @param {Crosspostingconnecthint32Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingconnecthint32 = /** @type {((inputs?: Crosspostingconnecthint32Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingconnecthint32Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingconnecthint32(inputs)
	return de_crosspostingconnecthint32(inputs)
});
export { crosspostingconnecthint32 as "crosspostingConnectHint3" }